/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { LoadMoreCollectionStories } from "@quintype/components";
import { object, func, array, bool } from "prop-types";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import CardImageType1 from "../../molecules/card-image-type-1";
import CardImageType9 from "../../molecules/card-image-type-9";
import ReadMore from "../../atoms/read-more";
import DfpAd from "../../dfp-ad";

import "./five-stories-with-loadmore.m.css";

class FiveStoriesWithLoadMore extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }
  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  render() {
    const { collection } = this.props;
    const storiesFromCollection = get(collection, ["items"], []).filter(items => items.type === "story") || [];
    const topTwoStories = storiesFromCollection && storiesFromCollection.length && storiesFromCollection.slice(0, 2);
    const renderTopTwoStoriesDom = topTwoStories
      ? topTwoStories.map((item, index) => <CardImageType1 story={item.story} key={index} />)
      : "No Stories Found";
    const sectionMeta = () => (
      <div styleName="section-header">
        {collection && collection.name && <Headline text={collection.name} headerType={12} headerLevel={3} />}
      </div>
    );
    const storiesDom = stories => {
      return stories.map((item, index) => {
        const storyObj = item.story || item;

        return (
          <React.Fragment key={index}>
            <div styleName="set-1-story">
              <CardImageType9 story={storyObj} />
            </div>
          </React.Fragment>
        );
      });
    };

    const storiesTemplate = ({ onLoadMore, stories, noMoreStories }) => {
      return (
        <div styleName="bottom-stories">
          {storiesDom(stories)}
          {storiesFromCollection.length <= 5 || (!noMoreStories && <ReadMore onClick={onLoadMore} />)}
        </div>
      );
    };

    return (
      <div styleName="wrapper">
        <div>
          {sectionMeta()}
          <div styleName="top-stories-with-ad">
            <div styleName="top-stories">{renderTopTwoStoriesDom}</div>
            <div styleName="ad-300x250">
              <DfpAd adtype="rectangle_1_300x250" />
            </div>
          </div>
          <div styleName="bottom-stories-with-sidebar">
            <LoadMoreCollectionStories
              template={storiesTemplate}
              data={{ stories: storiesFromCollection.slice(2, 5) }}
              collectionSlug={collection.slug}
              numStoriesToLoad={10}
              params={{ "item-type": "story" }}
            />
            <div>
              <DfpAd adtype="rectangle_1_300x250" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FiveStoriesWithLoadMore.propTypes = {
  collection: object,
  onLoadMore: func,
  stories: array,
  noMoreStories: bool
};

export default FiveStoriesWithLoadMore;
